import { createFileRoute } from '@tanstack/react-router'
import { useSetDetail } from '@/pages/organizations/detail/sets/detail'
import { useSelector } from 'react-redux'
// @ts-ignore
import SetReportDownload from '@/pages/organizations/detail/sets/detail/report/download'
import { Store } from '@/store/Store'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/sets/$setId/report/download/$format',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { format } = Route.useParams()
  const { assessment, organization } = useSetDetail()
  const currentUser = useSelector((state: Store) => state.auth.currentUser)

  return (
    <SetReportDownload
      currentUser={currentUser}
      assessment={assessment}
      organization={organization}
      set={assessment}
      format={format}
    />
  )
}
